import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext, useAuth } from 'context/AuthContext';
import { format, utcToZonedTime } from 'date-fns-tz';

import ArticlePlaceholder from 'components/ui/article-placeholder';

import { RiArrowLeftSLine } from 'react-icons/ri';
import { TfiMedallAlt } from 'react-icons/tfi';
import {
  deleteFeedbackEcoaByQuery,
  getPlayerInfo,
  getServerTime,
  getTasksManagerEcoa,
  playerLastManager,
  updateTaskEcoa,
  getNextManagers,
  getVerifyTaskEcoa,
} from 'services/dashboard.service';

import { TaskItem } from 'components/task-item';
import { Countdown } from 'components/countdown';
import { clamp, getTaskStep } from 'utils/helpers';
import { CheckManagerType, GetTaskStatusLabel } from 'utils/strings';
import { BiMinus, BiUpvote } from 'react-icons/bi';
import { FaCoins, FaEye } from 'react-icons/fa';
import { actionLog } from 'services/actionlog.service';
import Box from 'components/ui/box';
import { useModal } from 'context/ModalContext';
import { HiOutlineHandThumbDown, HiOutlineHandThumbUp } from 'react-icons/hi2';
import ImgFeedback from 'assets/img/comportamento/bg-missoes-not-found.png';
import { Step, User } from 'types/user';
import { getStorageItem } from 'utils/storage';
import { UserAvatar } from 'components/user-avatar';
import { BsChatText, BsPlusLg } from 'react-icons/bs';
import CustomSelect from 'components/custom-select';
import Detail from 'pages/MissaoDestaque/Detail';
// import Header from '../components/Header';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { subMinutes } from 'date-fns';
import { findLateralMenagers } from 'services/profile.service';
// import SelectGestor from '../components/SelectGestor';
// import ModalCod5 from '../components/ModalCod5';
// import CardPlus from '../components/CardPlus';

import CardIcon from 'assets/img/cards-icon.svg';
import { NotFound } from 'pages/NotFound';
import { TaskItemEcoa } from 'components/task-item-ecoa';
import { FiEye } from 'react-icons/fi';
import { getNamedDates, GetVersion } from 'services/utils';

export function ApreciarAcaoV3() {
  const location = useLocation();
  const navigate = useNavigate();
  const { showModal } = useModal();
  const { user, realCycle, cycleSelected, setCycleSelected } = useAuth();

  const [realDatetime, setRealDatetime] = useState<number>(0);

  const [internalUser, setInternalUser] = useState<User>();

  const [pageLoading, setPageLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [gestor, setIsGestor] = useState(false);
  const [data, setData] = useState<any[]>();

  const [filteredData, setFilteredData] = useState<any[]>();

  const [validTasks, setValidTasks] = useState<unknown[]>([]);
  const [knownTasks, setKnownTasks] = useState<unknown[]>([]);
  const [doubledTasks, setDoubledTasks] = useState<unknown[]>([]);
  const [promotedTasks, setPromotedTasks] = useState<unknown[]>([]);
  const [feedbackTasks, setFeedbackTasks] = useState<number | undefined>();

  const [maxValidTasks, setMaxValidTasks] = useState(0);
  const [maxKnownTasks, setMaxKnownTasks] = useState(0);
  const [maxDoubledTasks, setMaxDoubledTasks] = useState(0);
  const [maxPromotedTasks, setMaxPromotedTasks] = useState(0);

  const [activeTabDirector, setActiveTabDirector] = useState<'diretoria' | 'rede'>('diretoria');

  const [playerInfo, setPlayerInfo] = useState<any>();

  const [stages, setStages] = useState<Step[] | undefined>([]);
  const [currentCycle, setCurrentCycle] = useState<string | undefined>();
  const [optionsCycle, setOptionsCycle] = useState<any[]>([]);
  const [activeCycleSelected, setActiveCycleSelected] = useState<any>();
  const [cycleSelectedObject, setCycleSelectedObject] = useState<any>();
  const [evaluateStage, setEvaluateStage] = useState<any>();

  const [currentStage, setCurrentStage] = useState<string | undefined>();
  const [numberOfElements, setNumberOfElements] = useState(3);
  const [showMore, setShowMore] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [selectedGestor, setSelectedGestor] = useState<any>();
  const [functionGestor, setFunctionGestor] = useState<string>('');
  const [getAction, setGetAction] = useState<any>(false);
  const [modalCod5, setModalCod5] = useState<any>(undefined);
  const [bonus, setBonus] = useState<any>(undefined);
  const [loadBonus, setLoadBonus] = useState(true);
  const [hasTime, setHasTime] = useState(false);

  useEffect(() => {
    let interv: any = undefined;

    getServerTime().then(timestamp => {
      setRealDatetime(timestamp);
      setHasTime(true);

      interv = window.setInterval(() => {
        setRealDatetime(prevstate => prevstate + 1000);
      }, 1000);
    });

    return () => clearInterval(interv);
  }, []);

  const isVacationManager = useMemo(() => !!internalUser && !!user && internalUser._id !== user._id, [internalUser, user]);

  const activeStageObjEvaluate = useMemo(() => {
    if (stages) {
      return stages.find(e => e.status === 'evaluation');
    }

    return {};
  }, [stages]);

  const activeStageObj = useMemo(() => {
    if (!Array.isArray(stages) || !currentStage) return undefined;

    if (currentStage === 'semestral') {
      const cycle = realCycle?.find(x => x._id === activeCycleSelected);

      const evaluationStage = stages.find(x => x.status === 'evaluation') || stages[0];
      if (!evaluationStage || !cycle?.date_start || !cycle?.date_end) return undefined;

      const _stages = {
        ...evaluationStage,
        title: 'Semestral',
        date_start: cycle?.date_start,
        date_finish: cycle?.date_end,
      };

      return _stages;
    }

    return stages.find(x => x._id === currentStage);
  }, [activeCycleSelected, currentStage, realCycle, stages]);

  const getActiveEvaluationStep: 0 | 2 | 3 | 4 | 4.1 | 5 | null = useMemo((): 0 | 2 | 3 | 4 | 4.1 | 5 | null => {
    if (!activeStageObj || activeStageObj.status !== 'evaluation' || !realDatetime) return null;

    if (
      realDatetime > activeStageObj?.date_evaluation_step2_start &&
      realDatetime < activeStageObj?.date_evaluation_step2_finish
    ) {
      // Etapa 2
      return 2;
    } else if (
      realDatetime > activeStageObj?.date_evaluation_step3_start &&
      realDatetime < activeStageObj?.date_evaluation_step3_finish
    ) {
      // Etapa 3
      return 3;
    } else if (
      realDatetime > activeStageObj?.date_evaluation_step4_start &&
      realDatetime < activeStageObj?.date_evaluation_step4_finish
    ) {
      // Etapa 4
      return 4;
    } else if (
      realDatetime > activeStageObj?.date_evaluation_pitStop_start &&
      realDatetime < activeStageObj?.date_evaluation_pitStop_finish
    ) {
      // Pit Stop
      return 4.1;
    } else if (
      realDatetime > activeStageObj?.date_evaluation_step5_start &&
      realDatetime < activeStageObj?.date_evaluation_step5_finish
    ) {
      // Etapa 5
      return 5;
    } else {
      return 0;
    }
  }, [activeStageObj, realDatetime]);

  // Retorna a etapa atual da missão
  // const getTaskStep = useCallback((task: any) => {
  //   if (!task || typeof task.status !== 'string') return undefined;

  //   // Etapa 2
  //   if (
  //     (task.status === 'rejeitado' || task.status === 'aguardando') &&
  //     (typeof task.stageNumber === 'undefined' || task.stageNumber === 0)
  //   ) {
  //     return 2;
  //   }

  //   // Se tiver Pit Stop
  //   if (typeof task.prosseguir_gst === 'string') {
  //     if (task.prosseguir_gst === 'next' || task.prosseguir_gst === 'stopped') {
  //       return 4.1;
  //     } else {
  //       return 5;
  //     }
  //   }

  //   // Etapa 3, 4 e 5
  //   if (typeof task.multiplicador === 'number') {
  //     if (typeof task.stageNumber === 'number') {
  //       if (task.stageNumber === 1) {
  //         return 3;
  //       } else if (task.stageNumber === 2) {
  //         return 4;
  //       } else if (task.stageNumber === 3) {
  //         return 5;
  //       }
  //     } else {
  //       // Etapa 3
  //       if (task.multiplicador === 1) {
  //         return 3;
  //       }

  //       // Etapa 3
  //       if (task.status === 'dobrado' && task.multiplicador === 2) {
  //         return 3;
  //       }

  //       // Etapa 4
  //       if (task.status === 'promovido' && task.multiplicador === 2) {
  //         return 4;
  //       }

  //       // Etapa 4
  //       if (task.status === 'dobrado' && task.multiplicador === 4) {
  //         return 4;
  //       }

  //       // Etapa 5
  //       if (task.status === 'promovido' && task.multiplicador === 4) {
  //         return 5;
  //       }

  //       // Etapa 5
  //       if (task.status === 'dobrado' && task.multiplicador === 8) {
  //         return 5;
  //       }

  //       // Etapa 5
  //       if (task.status === 'selo') {
  //         return 5;
  //       }
  //     }
  //   }

  //   return undefined;
  // }, []);

  const getPlayerStep = useCallback(
    (task: any) => {
      if (!!task.prosseguir_idGestor && task.prosseguir_idGestor === playerInfo._id) {
        return 4.1;
      }

      if (typeof playerInfo.cod_etapa === 'number') {
        if (playerInfo.cod_etapa === 2) {
          return 2;
        }

        if (playerInfo.cod_etapa === 4) {
          if (String(task.original_manager) === String(playerInfo._id)) {
            if (task.status === 'rejeitado' || task.status === 'aguardando') {
              return 2;
            } else if (
              typeof task.multiplicador === 'number' &&
              (task.multiplicador === 1 || (typeof task.stageNumber === 'number' && task.stageNumber === 1))
            ) {
              return 3;
            } else {
              return 4;
            }
          } else {
            return 4;
          }
        }

        if (playerInfo.cod_etapa === 5) {
          if (String(task.original_manager) === String(playerInfo._id)) {
            if (task.status === 'rejeitado' || task.status === 'aguardando') {
              return 2;
            } else if (typeof task.stageNumber === 'number' && task.stageNumber === 1) {
              return 3;
            } else if (typeof task.stageNumber === 'number' && task.stageNumber === 2) {
              return 4;
            } else {
              return 5;
            }
          } else {
            return 5;
          }
        }

        if (playerInfo.cod_etapa === 1 || playerInfo.cod_etapa === 3) {
          if (String(task.original_manager) === String(playerInfo._id)) {
            if (task.status === 'rejeitado' || task.status === 'aguardando') {
              return 2;
            } else {
              return 3;
            }
          } else {
            return 3;
          }
        }

        return 0;
      }

      return 0;
    },
    [playerInfo],
  );

  const isOriginalManager = useMemo(() => {
    if (!filteredData?.length) return false;
    return !!filteredData.find(x => x.original_manager && x.original_manager === playerInfo?._id);
  }, [filteredData, playerInfo]);

  const isOriginalManagerCod5 = useMemo(() => {
    if (!filteredData?.length) return false;
    return !!filteredData.find(x => x.original_manager && x.original_manager === playerInfo?._id && playerInfo?.cod_etapa === 5);
  }, [filteredData, playerInfo]);

  const clarifyingText = useMemo(() => {
    if (
      !playerInfo ||
      !playerInfo.cod_etapa ||
      typeof playerInfo.cod_etapa !== 'number' ||
      playerInfo.cod_etapa < 1 ||
      playerInfo.cod_etapa > 5
    )
      return <></>;

    const _tasks = [...(filteredData as any[])];
    let stepMsg;

    if (playerInfo.cod_etapa === 4 && !!isOriginalManager) {
      if (typeof getActiveEvaluationStep === 'number') {
        if (getActiveEvaluationStep === 2) {
          stepMsg = 0;
        } else if (getActiveEvaluationStep === 3) {
          stepMsg = 1;
        } else {
          stepMsg = 2;
        }
      } else {
        stepMsg = 2;
      }
    } else if (playerInfo.cod_etapa === 5 && !!isOriginalManager) {
      if (typeof getActiveEvaluationStep === 'number') {
        if (getActiveEvaluationStep === 2) {
          stepMsg = 0;
        } else if (getActiveEvaluationStep === 3) {
          stepMsg = 1;
        } else if (getActiveEvaluationStep === 4 || getActiveEvaluationStep === 4.1) {
          stepMsg = 2;
        } else {
          stepMsg = 3;
        }
      } else {
        stepMsg = 3;
      }
    } else {
      if (playerInfo.cod_etapa === 2) {
        stepMsg = 0;
      } else if (playerInfo.cod_etapa === 4) {
        stepMsg = 2;
      } else if (playerInfo.cod_etapa === 5) {
        stepMsg = 3;
      } else if (playerInfo.cod_etapa === 1 || playerInfo.cod_etapa === 3) {
        if (_tasks.length) {
          let hasLevel1 = false;

          _tasks.forEach(task => {
            if (
              typeof getTaskStep(task) === 'number' &&
              (getTaskStep(task) as number) >= 3 &&
              ((typeof getActiveEvaluationStep === 'number' && getActiveEvaluationStep > 2) || getActiveEvaluationStep === null)
            ) {
              hasLevel1 = true;
            }
          });

          stepMsg = hasLevel1 ? 1 : 0;
        } else {
          stepMsg = 0;
        }
      }
    }

    if (typeof stepMsg === 'number') {
      if (stepMsg === 1) {
        return (
          <>
            <p className="text-dandelion text-lg font-semibold block mb-4">Apreciação das ações validadas</p>
            <p className="text-white text-base font-thin mb-1">
              Cada ação recebida por você foi <strong className="font-bold">validada</strong> por funcionário pertencente à função
              gerencial e recebeu 300 (trezentos) pontos.
            </p>
            <p className="text-white text-base font-thin mb-1">
              Nesta apreciação, você poderá BONIFICAR todas as ações que considerar mais relevantes em seu âmbito de atuação, e
              PROMOVER ao próximo nível, até 10% (dez por cento) das ações bonificadas que você considerar extraordinárias.
            </p>
            <p className="text-white text-base font-thin mb-1">
              A ação <strong className="font-bold">bonificada</strong> passará a 600 (seiscentos) pontos e a{' '}
              <strong className="font-bold">promovida</strong> terá 100 (cem) pontos adicionais.
            </p>

            <p className="text-white text-base font-light">
              <span className="text-electric-blue">Lembre-se</span> que ao deixar feedback para{' '}
              <strong className="font-bold">todas as entregas</strong> que você recebeu, além de promover o engajamento e o
              desenvolvimento de sua equipe, você também conquistará 100 (cem) pontos de bônus, conforme IN 403-1.
            </p>
          </>
        );
      } else if (stepMsg === 2) {
        return (
          <>
            <p className="text-dandelion text-lg font-semibold block mb-4">Apreciação das entregas promovidas pelo nível 1</p>
            <p className="text-white text-base font-thin mb-1">
              Cada ação recebida por você foi promovida por funcionário responsável pela apreciação nível l e recebeu 600
              (seiscentos) pontos.
            </p>
            <p className="text-white text-base font-thin mb-1">
              Nesta apreciação, você poderá BONIFICAR todas as ações que considerar mais relevantes para sua área de atuação, e
              PROMOVER ao próximo nível, até 10% (dez por cento) das ações bonificadas que você considerar extraordinárias.
            </p>
            <p className="text-white text-base font-thin mb-1">
              A ação <strong className="font-bold">bonificada</strong> passará a 1.200 (um mil e duzentos) pontos e a{' '}
              <strong className="font-bold">promovida</strong> terá 100 (cem) pontos adicionais.
            </p>

            <p className="text-white text-base font-light">
              <span className="text-electric-blue">Lembre-se</span> que ao deixar feedback para{' '}
              <strong className="font-bold">todas as entregas</strong> que você recebeu, além de promover o engajamento e o
              desenvolvimento de sua equipe, você também conquistará 100 (cem) pontos de bônus, conforme IN 403-1.
            </p>
          </>
        );
      } else if (stepMsg === 3) {
        return (
          <>
            <p className="text-dandelion text-lg font-semibold block mb-4">Apreciação das entregas promovidas pelo nível 2</p>
            <p className="text-white text-base font-thin mb-1">
              Cada ação recebida por você foi promovida por funcionário responsável pela apreciação nível 2 e recebeu 1.200 (um
              mil e duzentos) pontos.
            </p>
            <p className="text-white text-base font-thin mb-1">
              Nesta apreciação, você poderá BONIFICAR todas as ações que considerar mais relevantes para os desafios da sua
              Unidade/Diretoria, e conceder SELO AÇÃO DESTAQUE para até 10% (dez por cento) das ações bonificadas que você
              considerar extraordinárias.
            </p>
            <p className="text-white text-base font-thin mb-1">
              A ação <strong className="font-bold">bonificada</strong> passará a 2.400 (dois mil e quatrocentos) pontos e a que
              receber o <strong className="font-bold">SELO</strong> a 2.500 (dois mil e quinhentos) pontos.
            </p>

            <p className="text-white text-base font-light">
              E que tal deixar um feedback para a equipe? Afinal, reconhecimento nunca é demais!
            </p>
          </>
        );
      } else {
        return (
          <>
            <p className="text-dandelion text-lg font-semibold block mb-4">VALIDAÇÃO das entregas cadastradas por sua equipe</p>
            <p className="text-white text-base font-thin mb-1">
              Cada ação recebida por você foi cadastrada por um de seus liderados.
            </p>
            <p className="text-white text-base font-thin mb-1">
              Para VALIDAR a entrega, verifique se há alinhamento com os indicadores e desafios da equipe, se não há informações
              sigilosas, duplicidade e ou conteúdo inadequado, caso contrário você pode DEVOLVER a ação.
            </p>
            <p className="text-white text-base font-thin mb-1">
              Ao ser devolvida, a ação volta para o responsável pelo cadastramento e se for corrigida, dentro do período de
              validação, você poderá analisá-la novamente.
            </p>
            <p className="text-white text-base font-thin mb-1">
              A ação <strong className="font-bold">validada</strong> recebe 300 (trezentos) pontos.
            </p>

            <p className="text-white text-base font-light">
              <span className="text-electric-blue">Lembre-se</span> que ao deixar feedback para{' '}
              <strong className="font-bold">todas as entregas</strong> que você recebeu, além de promover o engajamento e o
              desenvolvimento de sua equipe, você também conquistará 100 (cem) pontos de bônus, conforme IN 403-1.
            </p>
          </>
        );
      }
    } else {
      return <></>;
    }
  }, [filteredData, getActiveEvaluationStep, isOriginalManager, playerInfo]);

  // TO DO: Mudar nomenclatura. Esse método não é utilizado apenas para reset.
  const canReset = useCallback(
    (task: any) => {
      const _activeStageObjEvaluate = stages && stages?.find(e => e.status === 'evaluation');

      const _activeStageObj =
        activeStageObj?._id === '67203cdf2cc06079269fffc0' && evaluateStage?._id === '67241c4a81985d067f49c740'
          ? evaluateStage
          : activeStageObj;

      const end = activeStageObj?.date_evaluation_step5_finish
        ? activeStageObj?.date_evaluation_step5_finish
        : activeStageObj?.date_evaluation_step4_finish
          ? activeStageObj?.date_evaluation_step4_finish
          : activeStageObj?.date_evaluation_step2_finish;

      if (
        !end ||
        !activeStageObj ||
        !getTaskStep(task) ||
        !getActiveEvaluationStep ||
        !playerInfo ||
        playerInfo?.ecoa !== 'TUTOR' ||
        !task.original_manager ||
        realDatetime < activeStageObj.date_evaluation_step2_start ||
        realDatetime > end
      ) {
        return false;
      }

      if (
        (getActiveEvaluationStep === 2 && (getTaskStep(task) as number) >= 2) ||
        (getActiveEvaluationStep === 5 && (getTaskStep(task) as number) >= 3)
      ) {
        return true;
      }

      if (task.status === 'apreciacaoExpirada') {
        return false;
      }

      return false;
    },
    [activeStageObj, evaluateStage, getActiveEvaluationStep, playerInfo, realDatetime, stages],
  );

  function canDouble(task: any) {
    if (!canReset(task) || !getTaskStep(task) || task.status !== 'aprovado' || !activeStageObj || currentStage !== 'semestral') {
      return false;
    }

    const hasDouble = data?.filter(e => e?.multiplicador > 1);

    if (
      !!activeStageObj &&
      (!hasDouble || !hasDouble?.length || hasDouble?.length < 1) &&
      realDatetime >= activeStageObj?.date_evaluation_step5_start &&
      realDatetime <= activeStageObj?.date_evaluation_step5_finish
    ) {
      return true;
    }

    return false;
  }

  function handleFinalize(task: any) {
    if (!canReset(task) || !getTaskStep(task) || task.status !== 'aprovado' || !activeStageObj || currentStage !== 'semestral') {
      return false;
    }

    const hasDouble = data?.filter(e => e?.multiplicador > 1);

    if (
      !!activeStageObj &&
      hasDouble &&
      realDatetime >= activeStageObj?.date_evaluation_step5_start &&
      realDatetime <= activeStageObj?.date_evaluation_step5_finish
    ) {
      return true;
    }

    return false;
  }

  function canPromote(task: any) {
    if (
      !canReset(task) ||
      !getTaskStep(task) ||
      !getActiveEvaluationStep ||
      (getTaskStep(task) !== getActiveEvaluationStep &&
        !(String(task.original_manager) === String(playerInfo._id) && playerInfo.cod_etapa === 5)) ||
      (getActiveEvaluationStep < 3 &&
        !(String(task.original_manager) === String(playerInfo._id) && playerInfo.cod_etapa === 5)) ||
      (promotedTasks.length >= maxPromotedTasks && (!bonus?.hasBonus || bonus?.isUsed)) ||
      typeof task.multiplicador !== 'number' ||
      typeof task.stageNumber !== 'number'
    ) {
      return false;
    }

    if (isVacationManager && promotedTasks.length >= maxPromotedTasks) return false;

    if (String(task.original_manager) === String(playerInfo._id) && playerInfo.cod_etapa === 5) {
      // Presidente e vice-presidente
      if (playerInfo.funcao_localizacao === 3001 || playerInfo.funcao_localizacao === 3002) {
        return false;
      } else {
        // Diretores e gerentes gerais
        if (getActiveEvaluationStep < 5) {
          return false;
        } else {
          return (
            getTaskStep(task) === getActiveEvaluationStep &&
            task.status === 'dobrado' &&
            task.multiplicador &&
            task.multiplicador === 8
          );
        }
      }
    }

    if (
      task.status === 'promovido' &&
      getTaskStep(task) === 4.1 &&
      getPlayerStep(task) === 4.1 &&
      getActiveEvaluationStep === 4.1 &&
      task.prosseguir_gst === 'next'
    ) {
      return true;
    }

    // if(getTaskStep(task) === 5 && task.multiplicador === 8 && promotedTasks.length >= maxPromotedTasks) {
    //   return false;
    // }

    if (task.status === 'dobrado') {
      if (getTaskStep(task) === 3 && task.multiplicador === 2) {
        return true;
      }

      if (getTaskStep(task) === 4 && task.multiplicador === 4) {
        return true;
      }

      if (getTaskStep(task) === 5 && task.multiplicador === 8) {
        return true;
      }
    }

    if (bonus?.hasBonus && !bonus?.isUsed && task.status === 'concluidoAuto' && !isVacationManager) return true;

    return false;
  }

  function canPromoteWithNoBonus(task: any) {
    if (
      !canReset(task) ||
      !getTaskStep(task) ||
      !getActiveEvaluationStep ||
      (getTaskStep(task) !== getActiveEvaluationStep &&
        !(String(task.original_manager) === String(playerInfo._id) && playerInfo.cod_etapa === 5)) ||
      (getActiveEvaluationStep < 3 &&
        !(String(task.original_manager) === String(playerInfo._id) && playerInfo.cod_etapa === 5)) ||
      promotedTasks.length >= maxPromotedTasks ||
      typeof task.multiplicador !== 'number' ||
      typeof task.stageNumber !== 'number'
    ) {
      return false;
    }

    if (isVacationManager && promotedTasks.length >= maxPromotedTasks) return false;

    if (String(task.original_manager) === String(playerInfo._id) && playerInfo.cod_etapa === 5) {
      // Presidente e vice-presidente
      if (playerInfo.funcao_localizacao === 3001 || playerInfo.funcao_localizacao === 3002) {
        return false;
      } else {
        // Diretores e gerentes gerais
        if (getActiveEvaluationStep < 5) {
          return false;
        } else {
          return (
            getTaskStep(task) === getActiveEvaluationStep &&
            task.status === 'dobrado' &&
            task.multiplicador &&
            task.multiplicador === 8
          );
        }
      }
    }

    if (
      task.status === 'promovido' &&
      getTaskStep(task) === 4.1 &&
      getPlayerStep(task) === 4.1 &&
      getActiveEvaluationStep === 4.1 &&
      task.prosseguir_gst === 'next'
    ) {
      return true;
    }

    // if(getTaskStep(task) === 5 && task.multiplicador === 8 && promotedTasks.length >= maxPromotedTasks) {
    //   return false;
    // }

    if (task.status === 'dobrado') {
      if (getTaskStep(task) === 3 && task.multiplicador === 2) {
        return true;
      }

      if (getTaskStep(task) === 4 && task.multiplicador === 4) {
        return true;
      }

      if (getTaskStep(task) === 5 && task.multiplicador === 8) {
        return true;
      }
    }

    return false;
  }

  function canValidate() {
    const _data = data?.filter(e => e.multiplicador >= 1);

    if (_data?.length) {
      return false;
    }

    return true;
  }

  function canEdit(task: any) {
    if (
      !activeStageObj ||
      activeStageObj.status !== 'evaluation' ||
      !canReset(task) ||
      playerInfo.ecoa !== 'TUTOR' ||
      task.status === 'concluido' ||
      task.status === 'concluidoAuto' ||
      task.status === 'apreciacaoExpirada'
    ) {
      return false;
    }

    if (task.status === 'aguardando') {
      return true;
    }

    if (task.status === 'aprovado' && getActiveEvaluationStep === 5) {
      return true;
    }

    if (task.multiplicador === 1 && getActiveEvaluationStep === 3) {
      return true;
    }

    if (task.status === 'promovido' && task.multiplicador === 2 && getActiveEvaluationStep === 4) {
      return true;
    }

    return false;
  }

  function canEvaluate(item: any) {
    try {
      const end = activeStageObj?.date_evaluation_step5_finish
        ? activeStageObj?.date_evaluation_step5_finish
        : activeStageObj?.date_evaluation_step4_finish
          ? activeStageObj?.date_evaluation_step4_finish
          : activeStageObj?.date_evaluation_step2_finish;

      if (
        !!activeStageObj &&
        !!end &&
        (activeStageObj.status === 'evaluation' ||
          (activeStageObj._id === '67203cdf2cc06079269fffc0' && evaluateStage?._id === '67241c4a81985d067f49c740')) &&
        realDatetime >= activeStageObj.date_evaluation_step2_start &&
        realDatetime <= end
      ) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }

  const getUserInfo = useCallback(async () => {
    try {
      const playerInfoResult = await getPlayerInfo(internalUser?._id);

      if (playerInfoResult) {
        setIsGestor(playerInfoResult.ecoa && playerInfoResult.ecoa === 'TUTOR');
        setPlayerInfo(playerInfoResult);

        setLoading(false);
      }
    } catch (e) {
      console.log(e);
    }
  }, [internalUser?._id]);

  const loadData = useCallback(
    async () => {
      if (!!activeStageObj) {
        const start =
          activeStageObj?._id === '67241c4a81985d067f49c740' && currentStage !== 'semestral'
            ? 1730174400000
            : activeStageObj.date_start;

        const end =
          activeStageObj?._id === '67203cdf2cc06079269fffc0' && currentStage !== 'semestral'
            ? 1733021999000
            : activeStageObj.date_finish;

        const myTasks = await getTasksManagerEcoa(internalUser?.extra.id, start, end);

        if (Array.isArray(myTasks) && myTasks.length) {
          setData(myTasks);
        } else {
          setData([]);
          setFilteredData([]);
          setLoading(false);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activeStageObj, internalUser?.extra.id],
  );

  async function updateAllTasks(action: string, newObj: any, oldObj?: any) {
    try {
      setPageLoading(true);
      if (!!action.match(/(accept|stop|reject)/g)) {
        await updateTaskEcoa(newObj);

        return true;
      } else if (!!action.match(/(double|reset)/g)) {
        if (action === 'double') {
          const tasks = [...(filteredData as any[])].filter((x: any) => {
            if (x._id !== newObj._id && canReset(x) && x.status === 'aprovado') {
              return true;
            }

            return false;
          });

          if (tasks.length) {
            // for (const task of tasks) {
            //   await updateTaskEcoa({ ...task, status: 'concluidoAuto' });
            // }

            await actionLog('me', 'change_task_ecoa_status', {
              tasks: tasks.map((x: any) => {
                return {
                  taskId: x._id,
                  status: 'concluidoAuto',
                };
              }),
            });
          }

          await updateTaskEcoa(newObj);
          return true;
        } else {
          const tasks = [...(filteredData as any[])].filter((x: any) => {
            if (x._id !== newObj._id && canReset(x) && x.status === 'concluidoAuto') {
              return true;
            }

            return false;
          });

          if (tasks.length) {
            // for (const task of tasks) {
            //   await updateTaskEcoa({ ...task, status: 'dobrado' });
            // }

            await actionLog('me', 'change_task_ecoa_status', {
              tasks: tasks.map((x: any) => {
                return {
                  taskId: x._id,
                  status: 'aprovado',
                };
              }),
            });
          }

          await updateTaskEcoa(newObj);
          return true;
        }
      }
    } catch (error) {
    } finally {
      await loadData();
      setPageLoading(false);
    }

    return null;
  }

  async function handleReset(task: any) {
    if (!canReset(task)) return false;

    const newObj = { ...task };

    delete newObj.evaluator;

    if (String(task.original_manager) === String(playerInfo._id) && playerInfo.cod_etapa === 5) {
      delete newObj.stageNumber;
      delete newObj.multiplicador;
      delete newObj.prosseguir_gst;
      delete newObj.prosseguir_idGestor;
      delete newObj.prosseguir_who_approved;

      // Presidente e vice-presidente
      if (playerInfo.funcao_localizacao === 3001 || playerInfo.funcao_localizacao === 3002) {
        newObj.status = 'aguardando';
      } else {
        // Diretores e gerentes gerais
        if (getActiveEvaluationStep && getActiveEvaluationStep < 5) {
          newObj.status = 'aguardando';
        } else {
          newObj.status = 'promovido';
          newObj.multiplicador = 4;
          newObj.stageNumber = 3;
        }
      }

      await deleteFeedbackEcoaByQuery(`taskId:'${newObj._id}'`);
    } else {
      if (getActiveEvaluationStep === 2) {
        delete newObj.stageNumber;
        delete newObj.multiplicador;
        delete newObj.prosseguir_gst;
        delete newObj.prosseguir_idGestor;
        delete newObj.prosseguir_who_approved;

        newObj.status = 'aguardando';

        await deleteFeedbackEcoaByQuery(`taskId:'${newObj._id}'`);
      } else {
        if (!!task.evaluator?.length && task.evaluator.includes(String(playerInfo._id))) {
          newObj.evaluator = [];

          for (let index = 0; index < task.evaluator.length; index++) {
            const id = task.evaluator[index];

            newObj.evaluator.push(id);

            if (id === String(playerInfo._id)) {
              break;
            }
          }
        }

        if (getActiveEvaluationStep && getActiveEvaluationStep > 2) {
          delete newObj.prosseguir_gst;
          delete newObj.prosseguir_idGestor;
          delete newObj.prosseguir_who_approved;

          newObj.status = 'aprovado';
          newObj.multiplicador = 1;
          newObj.stageNumber = 1;
        } else if (getActiveEvaluationStep === 4) {
          delete newObj.prosseguir_gst;
          delete newObj.prosseguir_idGestor;
          delete newObj.prosseguir_who_approved;

          newObj.status = 'promovido';
          newObj.multiplicador = 2;
          newObj.stageNumber = 2;
        } else if (getActiveEvaluationStep === 4.1) {
          delete newObj.prosseguir_who_approved;

          newObj.prosseguir_gst = 'next';
          newObj.status = 'promovido';
          newObj.multiplicador = 4;
          newObj.stageNumber = 3;
        } else if (getActiveEvaluationStep === 5) {
          newObj.status = 'promovido';
          newObj.multiplicador = 4;
          newObj.stageNumber = 3;
        }

        if (!!newObj.feedback?.length) {
          let evaluators: any;

          if (Array.isArray(newObj.evaluator)) {
            evaluators = [newObj.original_manager, ...newObj.evaluator];
          } else {
            evaluators = [newObj.original_manager];
          }

          const evaluatorsWithoutMe = evaluators.filter((x: string) => x !== String(playerInfo._id));

          const feedbacksWithoutMe = newObj.feedback
            .filter((x: any) => {
              if (evaluatorsWithoutMe?.length) {
                const evaluatorId = x.evaluatorId.replace(/F(0+)?/g, '');
                return !evaluatorsWithoutMe.includes(evaluatorId);
              }

              return true;
            })
            .map((x: any) => x._id);

          if (feedbacksWithoutMe.length) {
            const deletedFeedbacks: any = [];

            feedbacksWithoutMe.forEach((feedbackId: string) =>
              deletedFeedbacks.push(deleteFeedbackEcoaByQuery(`_id:'${feedbackId}'`)),
            );

            await Promise.all(deletedFeedbacks);
          }
        }
      }
    }

    // if (isVacationManager) {
    //   if (!newObj.substitute_managers) {
    //     newObj.substitute_managers = [];
    //   }

    //   const timestamp = await getServerTime();

    //   newObj.substitute_managers.push({
    //     playerId: user?._id,
    //     playerName: user?.name,
    //     status: 'reset',
    //     time: { $date: timestamp },
    //   });
    // }

    await updateAllTasks('reset', newObj, task);
  }

  async function handleAccept(item: any, gestor?: string) {
    if (!!gestor) {
      const valid = [...validTasks];
      const known = [...knownTasks];

      valid.push(item);
      known.push(item);

      setValidTasks(valid);
      setKnownTasks(known);
    }

    const updatedData = { ...item };

    updatedData.status = 'aprovado';
    updatedData.multiplicador = updatedData.multiplicador || 1;
    updatedData.stageNumber = 1;

    if (!!gestor) {
      setGetAction({ ...item, fuction: `validation-accept-${item._id}-finish` });
    }

    await updateAllTasks('accept', updatedData);
  }

  async function handleStop(item: any) {
    const managerTypeResult = CheckManagerType({
      user: playerInfo,
      item,
    });

    const updatedData = { ...item };

    if (
      updatedData.prosseguir_gst &&
      updatedData.prosseguir_gst === 'next' &&
      managerTypeResult === 'pitstop' &&
      updatedData.prosseguir_idGestor === playerInfo._id
    ) {
      updatedData.prosseguir_gst = 'stopped';
    }

    updatedData.status = 'concluido';

    if (isVacationManager) {
      if (!updatedData.substitute_managers) {
        updatedData.substitute_managers = [];
      }

      const timestamp = await getServerTime();

      updatedData.substitute_managers.push({
        playerId: user?._id,
        playerName: user?.name,
        status: 'concluido',
        time: { $date: timestamp },
      });
    }

    await updateAllTasks('stop', updatedData);
  }

  async function handleReject(item: any) {
    const rejected = [...knownTasks];
    rejected.push(item);
    setKnownTasks(rejected);

    const updatedData = { ...item };
    updatedData.status = 'rejeitado';

    if (isVacationManager) {
      if (!updatedData.substitute_managers) {
        updatedData.substitute_managers = [];
      }

      const timestamp = await getServerTime();

      updatedData.substitute_managers.push({
        playerId: user?._id,
        playerName: user?.name,
        status: 'rejeitado',
        time: { $date: timestamp },
      });
    }

    await updateAllTasks('reject', updatedData);
  }

  async function handleKnown(item: any) {
    const rejected = [...knownTasks];
    rejected.push(item);
    setKnownTasks(rejected);

    const updatedData = { ...item };
    updatedData.status = 'ciente';

    if (isVacationManager) {
      if (!updatedData.substitute_managers) {
        updatedData.substitute_managers = [];
      }

      const timestamp = await getServerTime();

      updatedData.substitute_managers.push({
        playerId: user?._id,
        playerName: user?.name,
        status: 'ciente',
        time: { $date: timestamp },
      });
    }

    await updateAllTasks('reject', updatedData);
  }

  async function handleDoubled(item: any) {
    if (String(item.original_manager) === String(playerInfo._id) && playerInfo.cod_etapa === 5) {
      // Presidente e vice-presidente
      if (playerInfo.funcao_localizacao === 3001 || playerInfo.funcao_localizacao === 3002) {
        return setModalCod5(item);
      } else {
        // Diretores e gerentes gerais
        if (getActiveEvaluationStep && getActiveEvaluationStep < 5) {
          return setModalCod5(item);
        }
      }
    }

    const doubled = [...doubledTasks];
    doubled.push(item);
    setDoubledTasks(doubled);

    let multiplicador = typeof item.multiplicador === 'number' ? item.multiplicador * 3 : 1;

    // const managerTypeResult = CheckManagerType({
    //   user: playerInfo,
    //   item,
    // });

    // if (managerTypeResult === 'solucoes') {
    //   multiplicador = 2;
    // } else if (managerTypeResult === 'executivo') {
    //   multiplicador = 4;
    // } else if (managerTypeResult === 'diretoria') {
    //   multiplicador = 8;
    // }

    const updatedData = { ...item };
    updatedData.status = 'dobrado';
    updatedData.multiplicador = multiplicador;

    // if (!canPromoteWithNoBonus(updatedData)) {
    //   updatedData.status = 'concluidoAuto';
    // }

    if (isVacationManager) {
      if (!updatedData.substitute_managers) {
        updatedData.substitute_managers = [];
      }

      const timestamp = await getServerTime();

      updatedData.substitute_managers.push({
        playerId: user?._id,
        playerName: user?.name,
        status: 'dobrado',
        time: { $date: timestamp },
      });
    }

    await updateAllTasks('double', updatedData);
  }

  async function handlePromote(item: any, gestor?: string) {
    const managerTypeResult = CheckManagerType({
      user: playerInfo,
      item,
    });

    const nextManagers = await getNextManagers(item._id);

    const promoted = [...promotedTasks];
    promoted.push(item);
    setPromotedTasks(promoted);

    const updatedData = { ...item };

    let stageNumber = updatedData.stageNumber;

    if (getTaskStep(item) === 3) {
      stageNumber = 2;
    } else if (typeof getTaskStep(item) === 'number' && (getTaskStep(item) as number) >= 4) {
      stageNumber = 3;
    }

    let managerProsseguir: null | string = null;

    if (playerInfo.prosseguir_gst === 1 && stageNumber === 3) {
      updatedData.prosseguir_gst = 'next';
      updatedData.prosseguir_idGestor = nextManagers && nextManagers.prosseguir ? nextManagers.prosseguir._id : playerInfo.gestor;

      if (Array.isArray(updatedData.prosseguir_managers)) {
        updatedData.prosseguir_managers.push(updatedData.prosseguir_idGestor);
      } else {
        updatedData.prosseguir_managers = [updatedData.prosseguir_idGestor];
      }
    } else if (
      updatedData.prosseguir_gst &&
      updatedData.prosseguir_gst === 'next' &&
      managerTypeResult === 'pitstop' &&
      stageNumber === 3
    ) {
      // const lastManager = await playerLastManager(internalUser?.extra.id);

      managerProsseguir = nextManagers && nextManagers.nivel3 ? nextManagers.nivel3._id : playerInfo.gestor;

      updatedData.prosseguir_gst = 'approved';
      updatedData.prosseguir_who_approved = playerInfo._id;
    }

    updatedData.status = 'promovido';
    updatedData.stageNumber = stageNumber;

    if (!updatedData.evaluator) {
      updatedData.evaluator = [];
    }

    if (managerTypeResult === 'diretoria') {
      // updatedData.multiplicador = 12;
      updatedData.status = 'selo';
      updatedData.evaluator.push('Selo Missão Destaque');
    } else if (playerInfo.gestor || managerProsseguir) {
      if (typeof managerProsseguir === 'string') {
        updatedData.evaluator.push(managerProsseguir);
        setGetAction({ ...item, fuction: `validation-promote-${item._id}-finish` });
      } else {
        if (updatedData.prosseguir_gst === 'next') {
          updatedData.evaluator.push(updatedData.prosseguir_idGestor);
          setGetAction({ ...item, fuction: `validation-promote-${item._id}-finish` });
        } else {
          if (
            playerInfo.cod_etapa === 4 &&
            String(updatedData.original_manager) === String(playerInfo._id) &&
            getActiveEvaluationStep &&
            getActiveEvaluationStep < 4
          ) {
            setGetAction({ ...item, fuction: `validation-promote-${item._id}-finish` });
          } else if (!gestor) {
            setSelectedGestor({
              task: item,
              cod: stageNumber === 2 ? [4] : [5],
              gestor:
                nextManagers[`nivel${stageNumber}`] && nextManagers[`nivel${stageNumber}`]._id
                  ? nextManagers[`nivel${stageNumber}`]._id
                  : playerInfo.gestor,
            });
            setFunctionGestor(`handlePromote`);
            return;
          }

          updatedData.evaluator.push(gestor);

          // updatedData.evaluator.push(
          //   nextManagers[`nivel${stageNumber}`] && nextManagers[`nivel${stageNumber}`]._id
          //     ? nextManagers[`nivel${stageNumber}`]._id
          //     : playerInfo.gestor,
          // );
        }
      }
    }

    if (isVacationManager) {
      if (!updatedData.substitute_managers) {
        updatedData.substitute_managers = [];
      }

      const timestamp = await getServerTime();

      updatedData.substitute_managers.push({
        playerId: user?._id,
        playerName: user?.name,
        status: updatedData.status,
        time: { $date: timestamp },
      });
    }

    if (
      playerInfo.cod_etapa === 4 &&
      String(updatedData.original_manager) === String(playerInfo._id) &&
      getActiveEvaluationStep &&
      getActiveEvaluationStep < 4
    ) {
      delete updatedData.evaluator;
    }

    if (!!gestor) {
      setGetAction({ ...item, fuction: `validation-promote-${item._id}-finish` });
    }

    await updateAllTasks('promote', updatedData);
  }

  async function handleSubmitCod5(task: any) {
    setModalCod5(undefined);

    let action = 'double';

    if (task.status === 'selo') {
      action = 'promote';
    } else if (
      playerInfo.funcao_localizacao !== 3001 &&
      playerInfo.funcao_localizacao !== 3002 &&
      task.multiplicador === 4 &&
      task.stageNumber === 3 &&
      task.status === 'promovido' &&
      getActiveEvaluationStep &&
      getActiveEvaluationStep < 5
    ) {
      action = 'promote';
    }

    document.dispatchEvent(
      new CustomEvent('open:modal-feedback', {
        detail: {
          _id: task._id,
        },
      }),
    );
    await updateAllTasks(action, task);
  }

  const isCurrentEvaluator = useCallback(
    (task: any) => {
      if (!internalUser || !task || !playerInfo) return false;

      let evaluators = [];

      if (!!task.original_manager?.length) {
        evaluators.push(task.original_manager);
      }

      if (Array.isArray(task.evaluator) && task.evaluator?.length) {
        evaluators = evaluators.concat(task.evaluator);
      }

      evaluators = evaluators.filter(x => !x.match(/selo/gi));

      if (evaluators.length) {
        const matriculaEvaluator = parseInt(evaluators[evaluators.length - 1].replace('F', ''));
        const currentId = parseInt(playerInfo._id);

        return matriculaEvaluator === currentId;
      } else {
        return false;
      }
    },
    [playerInfo, internalUser],
  );

  const tasksProsseguirAssessor: any[] = useMemo((): any[] => {
    if (!Array.isArray(filteredData) || !filteredData.length || !playerInfo) return [];

    const tasks = filteredData.filter(task => {
      if (!!task.prosseguir_idGestor && task.prosseguir_idGestor === playerInfo._id) return true;

      if (Array.isArray(task.prosseguir_managers) && !!task.prosseguir_managers.includes(playerInfo._id)) return true;

      return false;
    });

    return tasks;
  }, [filteredData, playerInfo]);

  const hasRede = useMemo(() => {
    if (!data || !data.length || !playerInfo || !activeStageObj) return undefined;

    const isDirector = playerInfo.cod_etapa && playerInfo.cod_etapa === 5;

    if (isDirector) {
      const itemsByStage = data?.filter(item => {
        return item.created >= activeStageObj?.date_start && item.created <= activeStageObj?.date_finish;
      });

      if (itemsByStage.length) {
        return !!itemsByStage.filter(
          (x: { prosseguir_gst: string; owner_tipo_classificacao: string }) =>
            (!!x.prosseguir_gst && x.prosseguir_gst === 'approved') ||
            (!!x.owner_tipo_classificacao && x.owner_tipo_classificacao === 'UNIDADE TÁTICA'),
        ).length;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }, [activeStageObj, data, playerInfo]);

  const htmlCountdownStep = useMemo(() => {
    if (!activeStageObj || !getActiveEvaluationStep || !data || !data.length || !playerInfo) return <></>;

    const itemsByStage: any[] = [...data];

    if (itemsByStage.length) {
      const userTaskStep: number[] = itemsByStage
        ?.map(task => (typeof getPlayerStep(task) === 'number' ? (getPlayerStep(task) as number) : 0))
        .sort(() => -1);

      if (userTaskStep.includes(getActiveEvaluationStep)) {
        const date_finish =
          getActiveEvaluationStep === 2
            ? activeStageObj?.date_evaluation_step2_finish
            : getActiveEvaluationStep === 3
              ? activeStageObj?.date_evaluation_step3_finish
              : getActiveEvaluationStep === 4
                ? activeStageObj?.date_evaluation_step4_finish
                : getActiveEvaluationStep === 4.1
                  ? activeStageObj?.date_evaluation_pitStop_finish
                  : activeStageObj?.date_evaluation_step5_finish;

        const levelTitle =
          getActiveEvaluationStep === 4.1
            ? 'Prosseguir'
            : getActiveEvaluationStep === 2
              ? 'Validação'
              : getActiveEvaluationStep === 3
                ? 'Nível 1'
                : getActiveEvaluationStep === 4
                  ? 'Nível 2'
                  : getActiveEvaluationStep === 5
                    ? 'Nível 3'
                    : null;

        return (
          <div className="py-4">
            {!!levelTitle && (
              <p className="text-xs text-alice-blue block font-thin">
                Fluxo de apreciação atual:{' '}
                <strong className="text-xs text-alice-blue block font-normal whitespace-nowrap">{levelTitle}</strong>
              </p>
            )}
            <p className="text-xs text-alice-blue block font-thin">
              O período de apreciação deste nível termina em:{' '}
              <strong className="text-xs text-alice-blue block font-normal whitespace-nowrap">
                <Countdown key="missao" deadline={new Date(date_finish)} />
              </strong>
            </p>
          </div>
        );
      } else {
        const hasAfter = userTaskStep?.find((x: number) => x > (getActiveEvaluationStep as number));

        const date_start =
          hasAfter === 2
            ? activeStageObj?.date_evaluation_step2_start
            : hasAfter && hasAfter >= 3
              ? activeStageObj?.date_evaluation_step5_start
              : 0;

        if (!!hasAfter && date_start) {
          return (
            <div className="py-4">
              <p className="text-xs text-alice-blue block font-thin">
                O período de apreciação começa em:{' '}
                <strong className="text-xs text-alice-blue block font-normal whitespace-nowrap">
                  <Countdown key="missao" deadline={new Date(date_start)} />
                </strong>
              </p>
            </div>
          );
        } else {
          return <></>;
        }
      }
    } else {
      const codEtapa =
        playerInfo.cod_etapa === 2
          ? 2
          : playerInfo.cod_etapa === 1 || playerInfo.cod_etapa === 3
            ? 3
            : playerInfo.cod_etapa === 4
              ? 4
              : playerInfo.cod_etapa === 5
                ? 5
                : null;

      if (codEtapa) {
        if (getActiveEvaluationStep === codEtapa) {
          const date_finish =
            getActiveEvaluationStep === 2
              ? activeStageObj?.date_evaluation_step2_finish
              : getActiveEvaluationStep === 3
                ? activeStageObj?.date_evaluation_step3_finish
                : getActiveEvaluationStep === 4
                  ? activeStageObj?.date_evaluation_step4_finish
                  : activeStageObj?.date_evaluation_step5_finish;

          return (
            <div className="py-4">
              <p className="text-xs text-alice-blue block font-thin">
                Fluxo de apreciação atual:{' '}
                <strong className="text-xs text-alice-blue block font-normal whitespace-nowrap">
                  {`Nível ${getActiveEvaluationStep}`}
                </strong>
              </p>
              <p className="text-xs text-alice-blue block font-thin">
                O período de apreciação deste nível termina em:{' '}
                <strong className="text-xs text-alice-blue block font-normal whitespace-nowrap">
                  <Countdown key="missao" deadline={new Date(date_finish)} />
                </strong>
              </p>
            </div>
          );
        } else {
          if (getActiveEvaluationStep < codEtapa) {
            const date_start =
              codEtapa === 2
                ? activeStageObj?.date_evaluation_step2_start
                : codEtapa === 3
                  ? activeStageObj?.date_evaluation_step3_start
                  : codEtapa === 4
                    ? activeStageObj?.date_evaluation_step4_start
                    : activeStageObj?.date_evaluation_step5_start;

            return (
              <div className="py-4">
                <p className="text-xs text-alice-blue block font-thin">
                  O período de apreciação começa em:{' '}
                  <strong className="text-xs text-alice-blue block font-normal whitespace-nowrap">
                    <Countdown key="missao" deadline={new Date(date_start)} />
                  </strong>
                </p>
              </div>
            );
          } else {
            return <></>;
          }
        }
      } else {
        return <></>;
      }
    }
  }, [activeStageObj, data, getActiveEvaluationStep, getPlayerStep, playerInfo]);

  const taskAppreciationExpired = useCallback(
    (task: any) => {
      const _taskStep = getTaskStep(task);
      const _playerStep = getPlayerStep(task);

      if (
        activeStageObj &&
        _taskStep &&
        ((_playerStep === 2 && task.status === 'aguardando' && realDatetime > activeStageObj.date_evaluation_step2_finish) ||
          (_playerStep === 4 &&
            _taskStep === 3 &&
            task.status === 'aprovado' &&
            task.multiplicador &&
            task.multiplicador === 1 &&
            realDatetime > activeStageObj.date_evaluation_step3_finish) ||
          (_playerStep === 5 &&
            _taskStep === 4 &&
            task.status === 'promovido' &&
            task.multiplicador &&
            task.multiplicador === 2 &&
            realDatetime > activeStageObj.date_evaluation_step4_finish))
      ) {
        return true;
      }

      return false;
    },
    [activeStageObj, getPlayerStep, realDatetime],
  );

  useEffect(() => {
    async function updateData() {
      if (typeof hasRede !== 'boolean') return setFilteredData([]);

      const isDirector = playerInfo.cod_etapa && playerInfo.cod_etapa === 5;

      try {
        let stageData: any = data?.filter(item => {
          if (currentStage === 'semestral' && item?.multiplicador >= 1) {
            return true;
          } else if (currentStage === 'semestral' && (!item?.multiplicador || item?.multiplicador < 1)) {
            return false;
          }

          if (activeStageObj?._id === '67241c4a81985d067f49c740') {
            return true;
          }

          if (activeStageObj?._id === '67203cdf2cc06079269fffc0') {
            return false;
          }

          return !!activeStageObj && item.created >= activeStageObj?.date_start && item.created <= activeStageObj?.date_finish;
        });

        if (!stageData) stageData = [];

        if (hasRede) {
          if (activeTabDirector === 'rede') {
            stageData = stageData.filter(
              (x: { prosseguir_gst: string; owner_tipo_classificacao: string }) =>
                (!!x.prosseguir_gst && x.prosseguir_gst === 'approved') ||
                (!!x.owner_tipo_classificacao && x.owner_tipo_classificacao === 'UNIDADE TÁTICA'),
            );
          } else {
            stageData = stageData.filter(
              (x: { prosseguir_gst: string; owner_tipo_classificacao: string }) =>
                !x.prosseguir_gst && (!x.owner_tipo_classificacao || x.owner_tipo_classificacao !== 'UNIDADE TÁTICA'),
            );
          }
        }

        let dataWithoutProsseguir = stageData;

        if (!isDirector) {
          dataWithoutProsseguir = stageData?.filter((task: any) => {
            if (!!task.prosseguir_idGestor && task.prosseguir_idGestor === playerInfo._id) return false;

            return true;
          });
        }

        setMaxValidTasks(stageData.length);

        setMaxKnownTasks(stageData.length);

        setFeedbackTasks(
          stageData.filter((task: any) => {
            if (
              !!Array.isArray(task.feedback) &&
              !!task.feedback.find(
                (x: any) =>
                  (x.evaluatorId === user?._id && !x.original_task_manager?.playerId) ||
                  (x.original_task_manager?.playerId && x.original_task_manager?.playerId === user?._id),
              )
            ) {
              return true;
            }

            return false;
          }).length,
        );

        const currentMaxDoubledTasks = dataWithoutProsseguir.filter((task: any) => {
          const _taskStep = getTaskStep(task);

          if (Array.isArray(task.prosseguir_managers) && !!task.prosseguir_managers.includes(playerInfo._id)) return false;

          if (
            String(task.original_manager) === String(playerInfo._id) &&
            playerInfo.cod_etapa === 5 &&
            !!getActiveEvaluationStep
          ) {
            // Presidente e vice-presidente
            if (playerInfo.funcao_localizacao === 3001 || playerInfo.funcao_localizacao === 3002) {
              return true;
            } else {
              // Diretores e gerentes gerais
              if (getActiveEvaluationStep < 5) {
                return true;
              } else {
                return task.stageNumber === 3;
              }
            }
          }

          if (
            task.status === 'rejeitado' ||
            taskAppreciationExpired(task) ||
            (typeof _taskStep === 'number' && typeof getPlayerStep(task) === 'number' && _taskStep < getPlayerStep(task)) ||
            (typeof _taskStep === 'number' &&
              typeof getActiveEvaluationStep === 'number' &&
              String(task.original_manager) !== String(playerInfo._id) &&
              isCurrentEvaluator(task) &&
              getActiveEvaluationStep < _taskStep) ||
            (playerInfo.cod_etapa === 4 && String(task.original_manager) === String(playerInfo._id) && !canReset(task))
          )
            return false;

          return true;
        });
        setMaxDoubledTasks(1);
        // setMaxDoubledTasks(clamp(Math.ceil(currentMaxDoubledTasks.length * 0.4), 1, Infinity));

        // console.log(
        //   'currentMaxDoubledTasks',
        //   currentMaxDoubledTasks.map((x: any) => x.title),
        // );

        setMaxPromotedTasks(clamp(Math.ceil(currentMaxDoubledTasks.length * 0.1), 1, Infinity));

        const currentValidTasks = stageData.filter(
          (item: any) => item.status !== 'rejeitado' && item.status !== 'aguardando' && item.status !== 'ciente',
        );
        setValidTasks(currentValidTasks);

        const currentKnownTasks = stageData.filter(
          (item: any) => item.status === 'ciente' || (item?.multiplicador && item.multiplicador >= 1),
        );
        setKnownTasks(currentKnownTasks);

        const currentDoubledTasks = stageData.filter((item: any) => item.multiplicador > 2);
        setDoubledTasks(currentDoubledTasks);

        // console.log(
        //   'currentDoubledTasks',
        //   currentDoubledTasks.map((x: any) => x.title),
        // );

        const currentPromotedTasks = dataWithoutProsseguir.filter((task: any) => {
          if (Array.isArray(task.prosseguir_managers) && !!task.prosseguir_managers.includes(playerInfo._id)) return false;

          if (
            String(task.original_manager) === String(playerInfo._id) &&
            playerInfo.cod_etapa === 5 &&
            !!getActiveEvaluationStep
          ) {
            // Presidente e vice-presidente
            if (playerInfo.funcao_localizacao === 3001 || playerInfo.funcao_localizacao === 3002) {
              return task.status === 'selo';
            } else {
              // Diretores e gerentes gerais
              if (getActiveEvaluationStep < 5) {
                return task.status === 'promovido' && task.multiplicador === 4 && task.stageNumber === 3;
              } else {
                return task.status === 'selo';
              }
            }
          }

          if (typeof getTaskStep(task) === 'number' && (getTaskStep(task) as number) > 2) {
            if ((getTaskStep(task) as number) === 5 && getPlayerStep(task) === 5 && task.status === 'selo') {
              return true;
            }

            if ((getTaskStep(task) as number) > getPlayerStep(task)) {
              return true;
            }

            if (
              getActiveEvaluationStep &&
              playerInfo.cod_etapa === 4 &&
              String(task.original_manager) === String(playerInfo._id) &&
              (getTaskStep(task) as number) > getActiveEvaluationStep
            ) {
              return true;
            }

            return false;
          }

          return false;
        });
        setPromotedTasks(currentPromotedTasks);

        // console.log(
        //   'currentPromotedTasks',
        //   currentPromotedTasks.map((x: any) => x.title),
        // );
        setFilteredData(stageData);

        setLoading(false);
      } catch (e) {
        setFilteredData([]);
        setLoading(false);
      }
    }

    updateData();
  }, [
    activeStageObj,
    activeTabDirector,
    canReset,
    currentStage,
    data,
    getActiveEvaluationStep,
    getPlayerStep,
    hasRede,
    isCurrentEvaluator,
    playerInfo,
    taskAppreciationExpired,
    user?._id,
  ]);

  useEffect(() => {
    if (!internalUser) return;

    setLoading(true);
    getUserInfo();
  }, [getUserInfo, internalUser]);

  useEffect(() => {
    if (!gestor || !cycleSelectedObject || !activeStageObj || !currentStage) return;

    setLoading(true);
    loadData();
  }, [gestor, loadData, cycleSelectedObject, activeStageObj, currentStage]);

  useEffect(() => {
    if (!stages) return;

    if (stages.length <= numberOfElements) {
      setShowMore(false);
    } else {
      setShowMore(true);
    }
  }, [numberOfElements, stages]);

  useEffect(() => {
    try {
      const locationState: any = location.state;

      if (locationState && locationState.direction) {
        if (locationState.direction === 'back') {
          if (gestor) {
            loadData();
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
  }, [gestor, loadData, location]);

  useEffect(() => {
    if (!user) return;

    async function handleUser() {
      if (!!user) {
        const storedManager = getStorageItem('manager_lateralidade');

        if (!!storedManager && storedManager.length) {
          const vacationManagers = await findLateralMenagers(undefined, storedManager);

          const vacationManager = vacationManagers?.length
            ? vacationManagers.find((x: { _id: any }) => x._id === storedManager)
            : null;

          if (!!vacationManager?._id && !!vacationManager.extra?.id) {
            setInternalUser(vacationManager);
          } else {
            setInternalUser(user);
          }
        } else {
          setInternalUser(user);
        }
      }
    }

    async function handleUserWLoading() {
      setLoading(true);
      // console.log('handleUserWLoading');
      handleUser();
    }

    handleUser();

    document.addEventListener('reload:lateralidade', handleUserWLoading, false);

    return () => {
      document.removeEventListener('reload:lateralidade', handleUserWLoading);
    };
  }, [user]);

  useEffect(() => {
    if (!activeCycleSelected || !realCycle || !hasTime) return;

    setLoadBonus(true);

    const _stages = realCycle?.find(x => x._id === activeCycleSelected)?.steps;
    setStages(_stages);

    const _stageActive = _stages?.find((item: any) => item.status === 'evaluation') || (_stages && _stages[0]);
    const _id =
      !!_stageActive &&
      realDatetime >= _stageActive?.date_evaluation_step5_start &&
      realDatetime <= _stageActive?.date_evaluation_step5_finish
        ? 'semestral'
        : _stageActive?._id;

    setCurrentStage(!!_id ? _id : Array.isArray(_stages) ? _stages[0]._id : undefined);

    setCycleSelectedObject(realCycle?.find(x => x._id === activeCycleSelected));

    setEvaluateStage(_stageActive);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeCycleSelected, realCycle, hasTime]);

  const configCycleAndStage = useCallback(() => {
    if (
      !user ||
      !realCycle ||
      !internalUser ||
      typeof currentCycle !== 'undefined' ||
      typeof currentStage !== 'undefined' ||
      !hasTime
    )
      return;

    const cycleOptions = realCycle
      .filter(e => e.date_start >= getNamedDates().ciclo_2S2024)
      .filter((item: any) => item.year > 2022)
      .map((cycle: any) => {
        cycle.label = 'Ciclo ' + cycle.title;
        cycle.value = cycle._id;

        return cycle;
      });

    const cycleActive = realCycle.find(x => x.status === 'open');
    const _currentCycle = !!cycleActive ? cycleActive._id : realCycle[0]._id;

    setOptionsCycle(cycleOptions);
    setCurrentCycle(_currentCycle);
    setActiveCycleSelected(cycleSelected?._id ? cycleSelected?._id : _currentCycle);

    const _stages = realCycle?.find(x => x._id === _currentCycle)?.steps;
    setStages(_stages);

    const _stageActive = _stages?.find((item: any) => item.status === 'evaluation');
    const _id =
      !!_stageActive &&
      realDatetime >= _stageActive?.date_evaluation_step5_start &&
      realDatetime <= _stageActive?.date_evaluation_step5_finish
        ? 'semestral'
        : _stageActive?._id;

    setCurrentStage(!!_id ? _id : Array.isArray(_stages) ? _stages[0]._id : undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentCycle, currentStage, cycleSelected?._id, internalUser, realCycle, user, hasTime]);

  useEffect(() => {
    if (!user || !realCycle) return;

    configCycleAndStage();
  }, [configCycleAndStage, realCycle, user]);

  function getIndexByValue(array: any, value: string) {
    return array.findIndex((element: any) => element.value === value);
  }

  const functionsObject: any = {
    handleAccept,
    handlePromote,
  };

   useEffect(() => {
    if (cycleSelected) {
      if (cycleSelected?.version && cycleSelected?.version) {
        navigate(`/${cycleSelected.version}/validar-acao-ecoa`);
      } else {
        navigate(`/validar-acao-ecoa`);
      }
    }
  }, [cycleSelected, navigate]);

  if (
    !user ||
    !internalUser ||
    typeof gestor !== 'boolean' ||
    typeof currentCycle === 'undefined' ||
    typeof currentStage === 'undefined' ||
    !activeStageObj
  )
    return null;

  if (!gestor && !loading) {
    return (
      <div className="mx-auto container p-4 lg:p-10">
        <div className="flex flex-row items-center space-x-4 mb-16">
          <div>
            <Link to="../">
              <button className="rounded-full bg-purple flex justify-center items-center p-1">
                <RiArrowLeftSLine size={28} className="text-white" />
              </button>
            </Link>
          </div>
          <h1 className="text-xl lg:text-3xl text-white font-semibold">Ação Destaque</h1>
        </div>

        <div className="border-2 border-electric-blue rounded-3xl p-8 bg-oxford-blue">
          <p className="text-dandelion text-lg font-semibold block text-center block">Você não possui acesso à esta página.</p>
        </div>
      </div>
    );
  }

  if (showDetail) return <Detail onClose={() => setShowDetail(false)} />;

  if (user?.extra.rede) return <NotFound />;

  return (
    <>
      {!!pageLoading && (
        <div className="fixed z-40 w-full h-full top-0 left-0 block flex items-center justify-center bg-black bg-opacity-60">
          <div role="status" className="flex items-center justify-center flex-col space-y-2 text-white">
            <svg
              aria-hidden="true"
              className="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
            <span className="text-white">Carregando...</span>
          </div>
        </div>
      )}

      <div className="mx-auto container p-3 lg:p-10 overflow-hidden">
        {/* <Header
          isRoot={true}
          onSubmitSearch={function (id: any): void {
            console.log(id);
          }}
        /> */}

        <div className="mb-3 lg:mb-16 flex justify-between items-center">
          <div className="flex flex-ro items-center space-x-3">
            <Link to="/">
              <button className="rounded-full bg-purple flex justify-center items-center p-1">
                <RiArrowLeftSLine size={28} className="text-white" />
              </button>
            </Link>

            <h1 className="text-lg lg:text-3xl py-1 rounded-full">Ações ECOA</h1>
          </div>
        </div>

        {/* <div className={`flex flex-row items-center space-x-4 mb-16`}>
          <div>
            <Link to="../">
              <button className="rounded-full bg-purple flex justify-center items-center p-1">
                <RiArrowLeftSLine size={28} className="text-white" />
              </button>
            </Link>
          </div>
          <h1 className="text-xl lg:text-3xl text-white font-semibold">Ação Destaque</h1>
        </div> */}

        {!!isVacationManager && !!internalUser && (
          <div className="border-2 border-electric-blue rounded-3xl px-8 py-6 mb-12 bg-rich-black bg-opacity-80 ">
            <p className="text-dandelion text-lg font-semibold block mb-3">
              Você está {playerInfo?.cod_etapa === 2 ? 'validando' : 'apreciando'} por:
            </p>

            <div className="flex flex-row items-center space-x-4">
              <div className="w-[44px] h-[44px]">
                <UserAvatar
                  data={{
                    image: internalUser.image,
                    ...internalUser.extra,
                  }}
                />
              </div>
              <p>
                <span className="text-xs font-thin">
                  <strong className="text-base font-semibold">{internalUser.name}</strong> ({internalUser._id})
                </span>
                <span className="block text-xs font-thin">
                  <span className="text-electric-blue uppercase">{internalUser.extra?.dependencia}</span> -{' '}
                  {internalUser.extra?.funcao}
                </span>
              </p>
              <Link
                to="/"
                className={`!ml-8 leading-none ring-2 ring-slate-blue w-full lg:w-auto flex flex-col lg:flex-row items-center bg-slate-blue text-center text-white hover:text-white hover:no-underline no-underline rounded py-2 px-3`}
              >
                SAIR
              </Link>
            </div>
          </div>
        )}

        <div className="border-2 border-electric-blue rounded-3xl p-8 mb-12 bg-oxford-blue">
          <p className="text-dandelion text-lg font-semibold block mb-3">Como funciona a dinâmica Ação ECOA?</p>
          <p className="text-white text-base font-light m-0">
            É uma ação contínua de engajamento para reconhecer e dar visibilidade às ações realizadas pelas Ecoas.
            <br />O coordenador da Ecoa cadastra as ações e o tutor pode dar ciência, validar e bonificar.
            {/* <br />
            Cadastre e descreva detalhadamente sua ação mais relevante do mês. Ela será apreciada pelos seus líderes e todos os
            participantes poderão receber pontos,
            <em className="italic">feedbacks</em> e <strong className="font-semibold">Selo Ação ECOA</strong>. */}
          </p>
        </div>

        <div className="rounded-xl overflow-hidden hidden lg:flex items-center justify-between mb-12">
          <button
            className={`${'bg-slate-blue'} w-full h-[86px] text-2xl text-white border-0 font-semibold flex items-center justify-center hover:opacity-80 transition-opacity`}
          >
            Validar Ações ECOA
          </button>
        </div>

        <div className="w-full flex flex-col lg:flex-row lg:justify-between">
          <div className="lg:w-[32.5%]">
            <div className="mb-5">
              <h2 className="text-xl text-white block mb-6 font-semibold">Histórico de Ações</h2>

              <Box>
                {loading || !filteredData ? (
                  <div className="grid grid-cols-1 gap-3">
                    <ArticlePlaceholder />
                  </div>
                ) : (
                  <>
                    <div className="px-8 mb-8">
                      <div>
                        <p className="mb-2">Escolha o ciclo que deseja acompanhar</p>

                        {optionsCycle && (
                          <div className="mb-4">
                            <CustomSelect
                              placeholder="Clique para selecionar o ciclo"
                              options={optionsCycle}
                              onChange={(e: any) => {
                                setActiveCycleSelected(e.value);
                                setCycleSelectedObject(e);

                                const selected = realCycle?.find(x => x._id === e.value);

                                if (selected) {
                                  setCycleSelected({
                                    _id: selected._id,
                                    title: selected.title,
                                    version: GetVersion(selected.date_start),
                                  });
                                }
                              }}
                              value={
                                optionsCycle.find(x => x.value === cycleSelected?._id)
                                  ? optionsCycle.find(x => x.value === cycleSelected?._id)
                                  : optionsCycle[getIndexByValue(optionsCycle, activeCycleSelected)]
                              }
                            />
                          </div>
                        )}
                      </div>

                      <p className="text-white mb-8 text-base font-normal block">Escolha a fase</p>

                      <ul className="space-y-4 flex flex-col">
                        {evaluateStage?.date_evaluation_step5_start && evaluateStage?.date_evaluation_step5_finish && (
                          <li>
                            <button
                              className={`${
                                currentStage === 'semestral' ? 'text-alice-blue bg-slate-blue' : 'text-white'
                              } text-sm flex items-center justify-center font-semibold uppercase ring-2 ring-slate-blue rounded w-full h-10`}
                              onClick={() => {
                                setCurrentStage('semestral');
                              }}
                            >
                              {evaluateStage?.semester_title}

                              {/* {GetTaskStatusLabel(cycle.status)} */}
                            </button>
                          </li>
                        )}
                        {stages &&
                          stages.slice(0, numberOfElements).map((cycle: any, index: number) => {
                            if (cycle.status !== 'evaluation' && !!isVacationManager) return null;

                            return (
                              <li key={cycle._id}>
                                <button
                                  className={`${
                                    currentStage === cycle._id ? 'text-alice-blue bg-slate-blue' : 'text-white'
                                  } text-sm flex items-center justify-center font-semibold uppercase ring-2 ring-slate-blue rounded w-full h-10`}
                                  onClick={() => {
                                    setCurrentStage(cycle._id);
                                  }}
                                >
                                  {cycle.title}
                                  {/* {GetTaskStatusLabel(cycle.status)} */}
                                </button>
                              </li>
                            );
                          })}

                        {!!stages && stages?.length > 3 && (
                          <button
                            className="mt-4 mx-auto flex items-center text-grey-light justify-center lg:justify-start"
                            onClick={() => (!showMore ? setNumberOfElements(3) : setNumberOfElements(numberOfElements + 3))}
                          >
                            {!showMore ? (
                              <>
                                <BiMinus className="mr-2 inline-block grey-dark" size={17} />
                                <span className="uppercase">Ver menos</span>
                              </>
                            ) : (
                              <>
                                <BsPlusLg className="mr-2 inline-block grey-dark" size={17} />
                                <span className="uppercase">Ver mais</span>
                              </>
                            )}
                          </button>
                        )}
                      </ul>
                    </div>

                    {activeStageObj?.status !== 'closed' ? (
                      <div className="bg-maastricht-blue rounded-3xl p-8 space-y-4">
                        <p className="block text-white leading-none font-normal text-base">
                          Ações da Fase {activeStageObj?.title}
                        </p>

                        {!!hasRede && (
                          <div className="flex items-center justify-between">
                            <button
                              className={`${
                                activeTabDirector === 'diretoria' ? 'text-alice-blue bg-slate-blue' : 'text-white'
                              } text-sm flex items-center justify-center font-semibold uppercase ring-2 ring-slate-blue rounded w-[45%] h-10`}
                              onClick={() => setActiveTabDirector('diretoria')}
                            >
                              Diretoria
                            </button>

                            <button
                              className={`${
                                activeTabDirector === 'rede' ? 'text-alice-blue bg-slate-blue' : 'text-white'
                              } text-sm flex items-center justify-center font-semibold uppercase ring-2 ring-slate-blue rounded w-[45%] h-10`}
                              onClick={() => setActiveTabDirector('rede')}
                            >
                              Rede
                            </button>
                          </div>
                        )}

                        {activeStageObj && activeStageObj.status === 'open' ? (
                          <>
                            <div>
                              <p className="text-xs text-alice-blue block font-thin">
                                O período de apreciação desta fase inicia em:
                              </p>
                              <div className="text-xs text-alice-blue block font-normal">
                                <Countdown key="missao" deadline={new Date(activeStageObj.date_finish)} />
                              </div>
                            </div>
                          </>
                        ) : null}

                        {activeStageObj && activeStageObj.status === 'evaluation' ? (
                          <>
                            {htmlCountdownStep}

                            {filteredData?.length ? (
                              <>
                                {!!isOriginalManager &&
                                typeof getActiveEvaluationStep === 'number' &&
                                getActiveEvaluationStep <= 2 ? (
                                  <>
                                    <div className="space-x-3 flex flex-row items-center justify-between pt-4 border-t border-prussian-blue-2">
                                      <HiOutlineHandThumbUp className="text-xl" />
                                      <span className="flex-1 text-white text-xs leading-none font-thin">
                                        Total de ações validadas
                                      </span>
                                      <div className="text-right text-yellow font-normal leading-none text-base">
                                        {validTasks.length}/1
                                      </div>
                                    </div>

                                    <div className="space-x-3 flex flex-row items-center justify-between pt-4 border-t border-prussian-blue-2">
                                      <FiEye className="text-xl" />
                                      <span className="flex-1 text-white text-xs leading-none font-thin">
                                        Total de ações cientes
                                      </span>
                                      <div className="text-right text-yellow font-normal leading-none text-base">
                                        {knownTasks.length}/{maxKnownTasks}
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )}

                                {playerInfo?.ecoa &&
                                playerInfo?.ecoa === 'TUTOR' &&
                                typeof getActiveEvaluationStep === 'number' &&
                                getActiveEvaluationStep > 2 ? (
                                  <>
                                    <div className="space-x-3 flex flex-row items-center justify-between pt-4 border-t border-prussian-blue-2">
                                      <FaCoins className="text-xl" />
                                      <span className="flex-1 text-white text-xs leading-none font-thin">
                                        Total de ações bonificadas
                                      </span>
                                      <div className="text-right text-yellow font-normal leading-none text-base">
                                        {doubledTasks.length}/{maxDoubledTasks ? maxDoubledTasks : 1}
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )}

                                <div className="space-x-3 flex flex-row items-center justify-between pt-4 border-t border-prussian-blue-2">
                                  <BsChatText className="text-xl" />
                                  <span className="flex-1 text-white text-xs leading-none font-thin">
                                    Total de feedbacks concedidos
                                  </span>
                                  <div className="text-right text-yellow font-normal leading-none text-base">
                                    {feedbackTasks}/{maxValidTasks}
                                  </div>
                                </div>
                              </>
                            ) : null}
                          </>
                        ) : null}
                      </div>
                    ) : (
                      <></>
                    )}
                  </>
                )}
              </Box>
            </div>

            {activeStageObj && activeStageObj._id !== '67203cdf2cc06079269fffc0' && (
              <div className="pt-3">
                <h2 className="text-xl text-white block mb-6 font-semibold">Calendário de validação/apreciação</h2>

                <Box className="relative bg-prussian-blue border-electric-blue p-4 lg:p-8 border-opacity-100 bg-opacity-100 w-full rounded-[20px]">
                  {loading ? (
                    <div className="grid grid-cols-1 gap-3">
                      <ArticlePlaceholder />
                    </div>
                  ) : (
                    <>
                      <div className="bg-maastricht-blue rounded-3xl p-8 space-y-4">
                        <p className="block text-white leading-none font-normal text-base pb-2">Fase {activeStageObj?.title}</p>

                        <div className="font-thin">
                          {activeStageObj.date_evaluation_step2_start && activeStageObj.date_evaluation_step2_finish && (
                            <p>
                              <span className="text-yellow font-light">
                                {format(activeStageObj.date_evaluation_step2_start, 'dd/MM')} a{' '}
                                {format(subMinutes(activeStageObj.date_evaluation_step2_finish, 10), 'dd/MM')}:
                              </span>{' '}
                              Validação
                            </p>
                          )}

                          {activeStageObj.date_evaluation_step3_start && activeStageObj.date_evaluation_step3_finish && (
                            <p className="pt-4 border-t border-prussian-blue-2">
                              <span className="text-yellow font-light">
                                {format(activeStageObj.date_evaluation_step3_start, 'dd/MM')} a{' '}
                                {format(subMinutes(activeStageObj.date_evaluation_step3_finish, 10), 'dd/MM')}:
                              </span>{' '}
                              Apreciação Nível 1
                            </p>
                          )}

                          {/* {activeStageObj.date_evaluation_step4_start && activeStageObj.date_evaluation_step4_finish && (
                            <p className="pt-4 border-t border-prussian-blue-2">
                              <span className="text-yellow font-light">
                                {format(activeStageObj.date_evaluation_step4_start, 'dd/MM')} a{' '}
                                {format(subMinutes(activeStageObj.date_evaluation_step4_finish, 10), 'dd/MM')}:
                              </span>{' '}
                              Apreciação Nível 2
                            </p>
                          )} */}

                          {/* {activeStageObj.date_evaluation_pitStop_start && activeStageObj.date_evaluation_pitStop_finish && (
                            <p className="pt-4 border-t border-prussian-blue-2">
                              <span className="text-yellow font-light">
                                {format(activeStageObj.date_evaluation_pitStop_start, 'dd/MM')} a{' '}
                                {format(subMinutes(activeStageObj.date_evaluation_pitStop_finish, 10), 'dd/MM')}:
                              </span>{' '}
                              PIT STOP - Ações da Rede
                            </p>
                          )} */}

                          {activeStageObj.date_evaluation_step5_start && activeStageObj.date_evaluation_step5_finish && (
                            <p className="pt-4 border-t border-prussian-blue-2">
                              <span className="text-yellow font-light">
                                {format(activeStageObj.date_evaluation_step5_start, 'dd/MM')} a{' '}
                                {format(subMinutes(activeStageObj.date_evaluation_step5_finish, 10), 'dd/MM')}:
                              </span>{' '}
                              Apreciação Bonificação
                            </p>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </Box>
              </div>
            )}

            {/* <div className="pt-6">
              <h2 className="text-xl text-white block mb-6 font-semibold">Ações da sua unidade</h2>

              <Box className="relative bg-prussian-blue border-electric-blue p-4 lg:p-8 border-opacity-100 bg-opacity-100 w-full rounded-[20px]">
                {loading ? (
                  <div className="grid grid-cols-1 gap-3">
                    <ArticlePlaceholder />
                  </div>
                ) : (
                  <>
                    <div className="px-8 flex flex-col items-center">
                      <p className="mb-5">Deseja acompanhar as Ações ECOA cadastradas pelos colegas da sua unidade?</p>

                      <button
                        className={`text-white text-sm flex items-center justify-center font-semibold uppercase ring-2 ring-slate-blue rounded w-full h-10`}
                        onClick={() => setShowDetail(true)}
                      >
                        ver ações
                      </button>
                    </div>
                  </>
                )}
              </Box>
            </div> */}
          </div>

          <div className="lg:w-[64.8%]">
            <h2 className="text-xl text-white block mb-6 font-semibold">
              Ações
              {!loading && filteredData ? ` Fase ${activeStageObj?.title}` : ''}
            </h2>

            <Box className="relative bg-prussian-blue border-electric-blue p-4 lg:p-8 border-opacity-100 bg-opacity-100 w-full rounded-[20px] space-y-6">
              {loading || !filteredData ? (
                <div className="grid grid-cols-1 gap-3">
                  <ArticlePlaceholder />
                </div>
              ) : filteredData?.length ? (
                filteredData?.map(item => (
                  <TaskItemEcoa
                    ecoa={true}
                    key={item._id}
                    editable={canEdit(item)}
                    onClearStatus={(item: any, status: any) => console.log('remove status', status, item)}
                    data={item}
                    manager={gestor}
                    managerType={CheckManagerType({
                      user: playerInfo,
                      item,
                    })}
                    playerInfo={playerInfo}
                    canEvaluate={canEvaluate(item)}
                    canValidate={canValidate()}
                    onAccept={handleAccept}
                    double={canDouble(item)}
                    onKnown={handleKnown}
                    onDouble={handleDoubled}
                    canFinalize={handleFinalize(item)}
                    onStop={handleStop}
                    onFeedback={() => loadData()}
                    onReload={() => loadData()}
                    cycle={activeStageObj}
                    activeEvaluationStep={getActiveEvaluationStep}
                    taskStep={getTaskStep(item)}
                    playerStep={getPlayerStep(item)}
                    onReset={handleReset}
                    reset={canReset(item)}
                    getAction={getAction}
                    clearGetAction={() => setGetAction(null)}
                  />
                ))
              ) : (
                <div className="flex justify-center items-center flex-col space-y-2 lg:space-y-8 bg-maastricht-blue-3 rounded-[20px] p-8 text-center">
                  <img src={ImgFeedback} className="max-w-[150px]" alt=" " />

                  <p className="text-lg block text-center font-thin text-white leading-loose tracking-tight">
                    <strong className="block text-center text-yellow font-semibold text-xl">
                      Sua equipe
                      {activeStageObj?.status === 'open' ? ' ainda ' : ' '}não cadastrou Ações ECOA nesta fase.
                    </strong>
                  </p>
                </div>
              )}
            </Box>
          </div>
        </div>
      </div>

      {/* <ModalConclude callback={callBackConclude} /> */}

      <Outlet />

      {/* {!!selectedGestor?.gestor && (
        <SelectGestor
          player={selectedGestor}
          closeModal={() => {
            setSelectedGestor(null);
            // loadData();
          }}
          onSubmit={(item: any) => {
            setSelectedGestor(null);
            functionsObject[functionGestor](selectedGestor.task, item._id);
          }}
        />
      )} */}

      {/* {!!modalCod5?._id && (
        <ModalCod5
          task={modalCod5}
          playerInfo={playerInfo}
          onSubmit={handleSubmitCod5}
          onClose={() => setModalCod5(undefined)}
          canPromote={promotedTasks.length < maxPromotedTasks}
        />
      )}

      {!loadBonus && canShowBonus && (!bonus || !bonus?.hasBonus) && <CardPlus onClose={() => getBonus()} />} */}
    </>
  );
}
